import * as rmd from 'material-ui';
import React from 'react';
import config from 'cfg';
import _ from 'lodash';
import moment from 'moment';

class StagePickerOneCheck extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            tournamentId: +props.tournamentId,
            seasonId: +props.seasonId,
            season: {},
            stageId: +props.stageId,
        };

        this.loadData();
    }

    componentWillReceiveProps = nextProps => {
        const { tournamentId, seasonId } = this.state;
        console.log('CWR', nextProps.tournamentId, nextProps.seasonId);
        console.log('old', tournamentId, seasonId);
        if (nextProps.tournamentId !== tournamentId || (nextProps.seasonId && nextProps.seasonId !== seasonId)) {
            this.setState(
                {
                    tournamentId: nextProps.tournamentId,
                    seasonId: nextProps.seasonId,
                    stageId: null,
                },
                () => {
                    this.loadData();
                    console.log('RESET STAGE');
                    // if was changed tournament and stageIds remains not empty (means previous) => reset them
                    if (nextProps.stageId !== null) this.props.onChange('stageId', null);
                },
            );
        }
    };

    componentDidMount() {
        console.log('CDM', this.props);
    }

    loadData = () => {
        const { tournamentId, seasonId } = this.state;
        if (!tournamentId) return Promise.resolve({});
        return fetch(`${config.apis.ss2}/tournaments/${tournamentId}/seasons`)
            .then(response => response.json())
            .then(seasons => {
                var season = _.find(seasons, s => {
                    if (!seasonId) return s.isCurrent;
                    return s.id === seasonId;
                });
                if (!season) season = _.last(seasons);

                this.setState({ season });
            })
            .catch(e => {
                console.error(e);
            });
    };

    handleStageCheck = stId => {
        const { stageId } = this.state;

        this.setState(
            {
                stageId: stageId !== stId ? stId : null,
            },
            () => {
                if (this.state.stageId === null) {
                    this.props.onChange('stageId', null);
                } else {
                    this.props.onChange('stageId', JSON.stringify(this.state.stageId));
                }
            },
        );
    };

    render() {
        const { season, stageId } = this.state;
        if (season.stages && season.stages.length === 1) return <div />;

        return (
            <div>
                <label style={{ marginTop: '10px', display: 'inline-block' }}>Select the Stage</label>
                {_.chain(season.stages || [])
                    .filter(st => (this.props.isLeague ? !st.isCup : true))
                    .groupBy(st => {
                        return moment(st.startDate).format('MMM YY') + ' - ' + moment(st.endDate).format('MMM YY');
                    })
                    .toPairs()

                    .map(p => {
                        const group = p[0];
                        const stages = p[1];

                        return [
                            <div style={{ padding: '10px 0' }}>{group}</div>,
                            _.sortBy(stages, st => p[1].rank).map(st => (
                                <rmd.Checkbox
                                    key={st.id}
                                    disabled={false}
                                    checked={stageId === st.id}
                                    onCheck={this.handleStageCheck.bind(this, st.id)}
                                    label={`${st.name}`}
                                />
                            )),
                        ];
                    })
                    .value()}
            </div>
        );
    }
}

export default StagePickerOneCheck;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/StagePickerOneCheck.js
 **/